import { MAGALU_DOMAIN } from '../../../constants';

const breadcrumbSchema = (data, domain = MAGALU_DOMAIN) => {
  if (!data || data.length === 0) return {};
  const magalu = [{
    name: 'magalu.com',
    position: 1,
    url: ''
  }];
  const breadcrumbList = [...magalu, ...data];
  const finalList = breadcrumbList.map(item => ({
    '@type': 'ListItem',
    position: item.position,
    item: {
      '@id': `${domain}${item == null ? void 0 : item.url}`,
      name: item.name
    }
  }));
  return {
    itemListElement: finalList
  };
};

export default breadcrumbSchema;